import { EventType } from '@/models/Interaction';
import { getChatAPI } from '@/api/ChatApi';
import {
  PaperFinderWidgetData,
  PaperFinderWidgetDataWithThread,
} from '@/models/PaperFinder';
import { RootState } from '@/store/store';
import { ThreadId } from '@/models/Thread';

import { createAsyncThunk } from '@reduxjs/toolkit';

export interface FetchPaperFinderError {
  errorMessage: string;
}

export const fetchLatestPaperFinderState = createAsyncThunk<
  PaperFinderWidgetDataWithThread,
  ThreadId,
  { state: RootState; rejectValue: FetchPaperFinderError }
>('data/fetchLatestPaperFinderState', async (threadId, { rejectWithValue }) => {
  try {
    const chatApi = getChatAPI();
    const { data } = await chatApi.getLatestEventOfType(
      threadId,
      EventType.WIDGET_PAPER_FINDER,
    );
    if (!data) {
      return rejectWithValue({ errorMessage: 'No data found' });
    }

    const widgetData: PaperFinderWidgetData | null = data.last_event
      ? (data.last_event?.data as PaperFinderWidgetData)
      : null;

    if (!widgetData) {
      return rejectWithValue({ errorMessage: 'No paper finder data found' });
    }

    return { threadId, data: widgetData };
  } catch (reportError) {
    if (reportError instanceof Error) {
      return rejectWithValue({ errorMessage: reportError.message });
    }

    throw reportError;
  }
});
